export default "__VITE_ASSET__277bdf69__"